import React from "react";
//#region types
import { TextInputProps, SelectInputProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { CustomerConstants } from "utils/constants";
import { AddressFieldProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { FormFieldLayout, VerticalFormField, TextInput, SelectInput } from "components/common/wintForms";
//#endregion
import { CountryHelper } from "utils/helpers";

const AddressField: React.FC<AddressFieldProps> = (props) => {
  const { connect, parentName, autogeneratedValues } = props;

  const parentNameFull: "generalInfo.billingAddress" | "generalInfo.deliveryAddress" = `generalInfo.${parentName}`;
  const street1Props = connect(`${parentNameFull}.street1`);
  const zipCodeProps = connect(`${parentNameFull}.zipCode`);
  const cityProps = connect(`${parentNameFull}.city`);
  const countryCodeProps = connect(`${parentNameFull}.countryCode`);

  const isAutoGenerated = JSON.stringify(connect(`${parentNameFull}`).value) === JSON.stringify(autogeneratedValues);

  return (
    <FormFieldLayout
      direction="horizontal"
      label={TranslationKeys.Common.Address}
      autogeneratedText={isAutoGenerated ? CustomerConstants.CustomerValuesAutogeneratedKey : undefined}
    >
      <Grid container direction="column" rowGap={1}>
        <VerticalFormField<TextInputProps>
          Component={TextInput}
          {...street1Props}
          label={TranslationKeys.Common.StreetAddress}
          maxLength={100}
          noOuterSpacing
          optional
        />
        <VerticalFormField<TextInputProps>
          Component={TextInput}
          {...connect(`${parentNameFull}.street2`)}
          label={TranslationKeys.Common.StreetAddress2}
          maxLength={100}
          noOuterSpacing
          optional
        />
        <Grid item container direction="row" columnGap={1} wrap="nowrap">
          <Grid item xs={6}>
            <VerticalFormField<TextInputProps>
              Component={TextInput}
              {...zipCodeProps}
              label={TranslationKeys.Common.PostalCode}
              maxLength={12}
              noOuterSpacing
              optional
            />
          </Grid>
          <Grid item xs={6}>
            <VerticalFormField<TextInputProps>
              Component={TextInput}
              {...cityProps}
              label={TranslationKeys.Common.City}
              maxLength={100}
              noOuterSpacing
            />
          </Grid>
        </Grid>
        <VerticalFormField<SelectInputProps>
          Component={SelectInput}
          {...countryCodeProps}
          label={TranslationKeys.Common.Country}
          items={CountryHelper.getCountrySelectionList()}
          noOuterSpacing
        />
      </Grid>
    </FormFieldLayout>
  );
};

export default AddressField;
